// Images
require.context("../images", true)

// CSS
import "stylesheets/blogs.scss"
